module.exports = __webpack_public_path__ + "img/icon-clubs-post.a5b244a2.png";